import { DateTime } from "luxon";

const ISO_WITH_OFFSET_PATTERN = /([+-]\d{2}:\d{2}|Z)$/;

/**
 * Rewrites datetimes into local ISO strings with an explicit offset so the
 * calendar date matches what the user selected in the picker (see AR-507).
 */
export const normalizeDatetimeForWrite = (
  datetime?: string | null,
): string | undefined => {
  if (!datetime) {
    return undefined;
  }

  const parsed = DateTime.fromISO(datetime);
  if (!parsed.isValid) {
    return datetime;
  }

  const local = parsed.toLocal();
  const normalized =
    DateTime.fromObject(
      {
        year: local.year,
        month: local.month,
        day: local.day,
        hour: local.hour,
        minute: local.minute,
        second: 0,
        millisecond: 0,
      },
      { zone: local.zoneName },
    ).toISO() ?? datetime;

  if (!ISO_WITH_OFFSET_PATTERN.test(normalized)) {
    return parsed.toLocal().toISO() ?? datetime;
  }

  return normalized;
};
